var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.793,
    y: 14,
    width: 22,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.793,
    y: 20,
    width: 22,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.793,
    y: 26,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.793,
    y: 32,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.793,
    y: 38,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.793,18.586v-10L31.207,1H0.793v48h38V31.414L49.207,21l-6.414-6.414L38.793,18.586z M37.793,22.414L41.379,26l-12,12 h-3.586v-3.586L37.793,22.414z M31.793,4.414L35.379,8h-3.586V4.414z M36.793,47h-34V3h27v7h7v10.586l-13,13V40h6.414l6.586-6.586 V47z M42.793,24.586L39.207,21l3.586-3.586L46.379,21L42.793,24.586z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.414e45144e9baea2089ddf419ca47aa0.svg";
export { ForwardRef as ReactComponent };